import { decodeHandoffTenant } from './handoffToken';

const STORAGE_KEY = 'portal_admin_tenant_override';

/**
 * The tenant an admin's portal session should scope to, derived from the URL.
 * Off the HITL review, the explicit `?tenant=` override is the only source. On
 * `/portal/hitl-review` the handoff token is AUTHORITATIVE — the chat/resolve
 * always use it — so the shell must match: prefer the token over `?tenant=` there
 * (falling back to `?tenant=` only if the token is missing/unreadable). Returns
 * null when neither applies. Feed the result to `resolveAdminPortalTenantId`.
 */
export function adminUrlTenant(search: URLSearchParams, pathname: string): string | null {
  if (pathname.startsWith('/portal/hitl-review')) {
    return decodeHandoffTenant(search.get('t') || '') ?? search.get('tenant');
  }
  return search.get('tenant');
}

/** Persisted ?tenant= for admins so in-portal navigation keeps the scoped tenant. */
export function getPortalAdminTenantOverride(): string | null {
  try {
    return sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function setPortalAdminTenantOverride(tenantId: string): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, tenantId);
  } catch {
    // Ignore quota / private-mode errors — URL param still works for the landing page.
  }
}

export function clearPortalAdminTenantOverride(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // Ignore
  }
}

/** URL param wins; otherwise fall back to the persisted admin override. */
export function resolveAdminPortalTenantId(urlTenant: string | null): string | null {
  if (urlTenant) {
    setPortalAdminTenantOverride(urlTenant);
    return urlTenant;
  }
  return getPortalAdminTenantOverride();
}
